// Shift-time preferences from the Users MULTI_SELECT field. `value` matches the
// resolved option name the backend returns on each worker (worker.shiftPref);
// `label` is the friendlier text for the filter dropdown. Order = time of day.
export const SHIFT_PREFS = [
  { value: "Day", label: "Day" },
  { value: "Afternoon", label: "Afternoon" },
  { value: "Evening", label: "Evening" },
  { value: "Overnight", label: "Overnight" },
  { value: "Shorter Shifts (4-6 hours for CNAs)", label: "Shorter shifts" },
];

const SHORT = { "Shorter Shifts (4-6 hours for CNAs)": "Shorter" };

// Compact chip label + a stable CSS class (pref-day, pref-evening, …).
export function shortPref(name) { return SHORT[name] || name; }
export function prefClass(name) { return `pref-${String(name || "").split(" ")[0].toLowerCase()}`; }
